// lib/axiosInstance.ts

import axios from 'axios';
import backendURL from "../config";

// Create an Axios instance
const axiosInstance = axios.create({
  // You can set a base URL for all requests
  // In Next.js, internal API routes are available at /api
  baseURL: backendURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- 1. REQUEST Interceptor (runs "before" the request is sent) ---
axiosInstance.interceptors.request.use(
  (config) => {
    // This is the ideal place to add an authorization token to headers
    // For this demo, we are reading the user object from localStorage.
    // In a real app, you would likely store and send a JWT token.
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        // In a real JWT setup, you'd do:
        const userdata = JSON.parse(storedUser);
        config.headers['Authorization'] = `Bearer ${userdata.access_token}`;
        config.headers['X-Active-Team-ID'] = userdata.active_team.team_id;
      }
    } catch (e) {
      console.error('Could not retrieve user from localStorage', e);
    }
    
    // When sending FormData (file uploads), remove the default Content-Type
    // so the browser can auto-set multipart/form-data with the correct boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // You must return the config object, or the request will be blocked
    return config;
  },
  (error) => {
    // Handle request errors (e.g., network issues)
    return Promise.reject(error);
  }
);


// --- 2. RESPONSE Interceptor (runs "after" a response is received) ---
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx triggers this function.
    // We can simply return the response.
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx triggers this function.
    
    // --- Global Error Handling ---
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const isPublicPage = window.location.pathname.startsWith('/invitation-external')
        || window.location.pathname === '/login'
        || window.location.pathname === '/registration';
      if (error.response.status === 401 && !isPublicPage) {
        // This is a critical global action.
        // If we get a 401, it means the user is not authenticated.
        console.error("Unauthorized request. Logging out and redirecting.");

        // Clear user data from storage
        localStorage.clear();

        //Redirect to the login page. We use window.location to force a
        //full page refresh, which clears all application state.
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
      }
    }
    
    // Return the error so that the .catch() block in our component can handle it
    return Promise.reject(error);
  }
);

export default axiosInstance;